


















































import { Component } from "vue-property-decorator";
import Header from "@/components/header/MLoginHeader.vue";
import Footer from "@/components/Footer.vue";
import AdminsApi from "@/services/AdminsApi";
import CheckAdminLogin from "@/utils/CheckAdminLogin";
import { sortCreatedAt } from "@/utils/Util";
import { Admin } from "@/api/lab-base-api-client";

@Component({
  components: {
    Header,
    Footer,
  },
})
export default class MAdminList extends CheckAdminLogin {
  // 削除済みユーザー表示スイッチ初期値
  private isIncludeDelete = false;

  // tableの検索初期値
  private search = "";

  // tableのheader設定配列
  private headers = [
    {
      text: "manager name",
      sortable: false,
      value: "name",
    },
    {
      text: "mail adress",
      value: "email",
    },
  ];

  // tableのデータ配列
  private listItems: Admin[] = [];

  // ページ読み込み時に実行
  private async mounted() {
    this.fetchList();
    this.listItems.sort(sortCreatedAt);
  }

  // 削除済みユーザー表示スイッチ切り替え時に実行
  private async onIncludeDelete() {
    if (this.isIncludeDelete === true) {
      const admins = await AdminsApi.instance.getAdmins(
        undefined,
        undefined,
        undefined,
        undefined,
        this.isIncludeDelete
      );

      this.listItems = admins.data.data.items;
    } else {
      this.fetchList();
    }
    this.listItems.sort(sortCreatedAt);
  }

  // admin一覧の取得
  private async fetchList() {
    const AdminsRes = await AdminsApi.instance.getAdmins();
    this.listItems = AdminsRes.data.data.items;
  }
}
